import { useCallback } from 'react'
import { AMPLITUDE_EVENTS, logAmplitudeEvent } from '../utils'
import { useActiveChatId } from '../store'

export const useTrackAddAttachment = () => {
  const activeChatId = useActiveChatId()
  return useCallback(
    (options: AMPLITUDE_EVENTS['Add Attachment']) => {
      logAmplitudeEvent('Add Attachment', { ...options, isNewChat: !activeChatId })
    },
    [activeChatId],
  )
}

export const useTrackRemoveAttachment = () => {
  const activeChatId = useActiveChatId()
  return useCallback(
    (options: AMPLITUDE_EVENTS['Remove Attachment']) => {
      logAmplitudeEvent('Remove Attachment', { ...options, isNewChat: !activeChatId })
    },
    [activeChatId],
  )
}
